export enum TimeFrameEnum {
    Monthly = 1,
    Weekly = 2
}